import React from 'react';
import { usePageSeo } from "../../shared/seo";

const ContactUs = () => {
  usePageSeo("contact");

  return (
    <div>
      <h2>Contact Us</h2>
      <p>Get in touch with Fugu's</p>
      <div>
        <p>Email: fugusfresh@gmail.com</p>
        <p>Phone: +1 (555) 123-4567</p>
        <p>Address: 123 Ocean Drive, Seafood City</p>
      </div>
    </div>
  );
};

export default ContactUs;
